import React, { useEffect, useState } from "react";
import "./style.css";
import { ENDPOINT, S3_URL, FE_ENDPOINT } from "../config";
import $ from "jquery";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Modal from "react-modal";
import axios from "axios";
import GoodieBag from "./GoodieBag.js";
import DefaultCard from "./DefaultCard.js";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import Navbar from "./Navbar";

Modal.setAppElement("#root");

const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
};

const JiveBirdTemp = (props) => {
  const [responseData, setResponseData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  const [songName, setSongName] = useState("");
  const [songNameVisible, setSongNameVisible] = useState(false);
  const [wasPlayed, setWasPlayed] = useState(false);
  const [cardUrl, setCardUrl] = useState("");
  const [recordingLink, setRecordingLink] = useState("");
  const [songLink, setSongLink] = useState("");
  const [sender, setSender] = useState("");

  const [giftLogo, setGiftLogo] = useState("");
  const [giftClaimUrl, setGiftClaimUrl] = useState("");

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [shareModalIsOpen, setShareModelOpen] = useState(false);
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [allDataReady, setAllDataReady] = useState(false);
  const [sendingThanks, setSendingThanks] = useState(false);

  const size = useWindowSize();
  const {
    match: {
      params: { id },
    },
  } = props;

  const testVideoAvailability = async (url) => {
    return new Promise((resolve) => {
      if (!url) {
        resolve(true);
        return;
      }

      const video = document.createElement("video");
      video.preload = "metadata";
      video.src = url;
      video.style.display = "none";

      let timeoutId = setTimeout(() => {
        console.log("Video test timeout, proceeding anyway");
        document.body.removeChild(video);
        resolve(true);
      }, 3000);

      video.onloadedmetadata = () => {
        clearTimeout(timeoutId);
        console.log("Video metadata loaded successfully");
        document.body.removeChild(video);
        resolve(true);
      };

      video.onerror = () => {
        clearTimeout(timeoutId);
        console.log("Video test failed, but proceeding anyway");
        if (document.body.contains(video)) {
          document.body.removeChild(video);
        }
        resolve(true);
      };

      document.body.appendChild(video);
    });
  };

  useEffect(() => {
    console.log("New Deployyy");
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${ENDPOINT}/jbcards/show/jb/${id}`, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        setResponseData(responseData);
        console.log("response", responseData);

        const dataToSet = {
          cardUrl: responseData.card_image_url || "",
          recordingLink: responseData.recording_link
            ? `${S3_URL}/${responseData.recording_link}`
            : "",
          songLink: responseData.song_link
            ? `${S3_URL}/${responseData.song_link}`
            : "",
          giftLogo: responseData.gift_logo_url || "",
          giftClaimUrl: responseData.gift_claim_url || "",
          sender: responseData.sender || "",
          songName: responseData.song_title || "",
        };

        setCardUrl(dataToSet.cardUrl);
        setRecordingLink(dataToSet.recordingLink);
        setSongLink(dataToSet.songLink);
        setGiftLogo(dataToSet.giftLogo);
        setGiftClaimUrl(dataToSet.giftClaimUrl);
        setSender(dataToSet.sender);
        setSongName(dataToSet.songName);

        let finalVideoLink = "";
        if (
          responseData.card_video_url &&
          responseData.card_video_url !== "" &&
          responseData.card_video_url !== null &&
          responseData.card_video_url !== "null"
        ) {
          const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );

          if (isIOS || isSafari) {
            finalVideoLink = responseData.card_video_url.replace(
              "/webapp-assets/",
              "/converted/"
            );
          } else {
            finalVideoLink = responseData.card_video_url;
          }

          console.log("Testing video availability:", finalVideoLink);
          await testVideoAvailability(finalVideoLink);
        }

        setVideoLink(finalVideoLink);
        setIsVideoReady(true);
        setAllDataReady(true);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(true);
        setLoading(false);
        setIsVideoReady(true);
        setAllDataReady(true);
      }
    };

    fetchData();
    checkWasPlayed();
  }, [id]);

  const checkWasPlayed = async () => {
    if (!wasPlayed) {
      try {
        let formData = new FormData();
        formData.append("access_code", id);

        await axios.post(`${ENDPOINT}/jbcards/play`, formData);
        setWasPlayed(true);
      } catch (error) {
        console.log("error marking as played", error);
      }
    }
  };

  const donwloadForms = document.querySelectorAll("#download form");
  donwloadForms.forEach((element, i) => {
    $(element).submit(function (e) {
      e.preventDefault();
      download(element);
    });
  });

  function download(e) {
    e.preventDefault();

    if (responseData.call_me || responseData.card_type === "CARD") {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," +
          encodeURIComponent(document.documentElement.outerHTML)
      );
      element.setAttribute("download", "JiveBird.html");
    } else {
      var blob = new Blob([document.documentElement.outerHTML], {
        type: "data:text/plain",
      });
      element = document.createElement("a");
      element.setAttribute("href", URL.createObjectURL(blob));
      element.setAttribute("download", "JiveBird.html");
      element.setAttribute("target", "_blank");
    }

    element.style.display = "none";
    document.body.appendChild(element);
    element.click();

    if (responseData.card_type === "CARD") {
      element = document.createElement("a");
      element.setAttribute("href", $("#song1")[0].src);
      element.setAttribute("download", "test.wav");
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }

  const sendThanksEmail = async (e) => {
    e.stopPropagation();
    if (!responseData || sendingThanks) return;

    const payload = {
      sender_email: responseData.sender_email || "",
      sender_name:
        responseData.sender_name || responseData.sender || "",
      recipient_name:
        responseData.recipient_name || responseData.recipient || "",
      viewer_link: `${FE_ENDPOINT}/${id}`,
    };

    try {
      setSendingThanks(true);
      await axios.post(
        `${ENDPOINT}/jbcards/send_thanks_email/`,
        payload
      );
      alert("Thank you email has been sent!");
    } catch (err) {
      console.error("Error sending thank you email:", err);
      alert("Could not send thank you email. Please try again.");
    } finally {
      setSendingThanks(false);
    }
  };

  if (error) {
    return (
      <div className="container mt-3">
        <h3>
          <b>
            Could not find the file for Jive Bird Card: "{id}".
            <br /> Please ensure that you are on the correct link. Try
            refreshing this page or try again later.
          </b>
        </h3>
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className="container mt-3"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <div>Loading your JiveBird...</div>
      </div>
    );
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      borderRadius: "12px",
      border: "2px solid #e5d8f2",
      boxShadow: "0 6px 20px rgba(115, 67, 133, 0.15)",
      textAlign: "center",
      position: "relative",
      width: "300px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      zIndex: 1000,
    },
  };

  const customStyles1 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      borderRadius: "12px",
      backgroundColor: "#fff",
      border: "2px solid #e5d8f2",
      boxShadow: "0 8px 28px rgba(115, 67, 133, 0.1)",
      textAlign: "center",
      maxWidth: "400px",
      width: "90%",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      zIndex: 1000,
    },
  };

  return (
    <>
      <Navbar
        sender={sender}
        songNameVisible={songNameVisible}
        songName={songName}
      />

      {allDataReady && isVideoReady && (
        <GoodieBag
          videoLink={videoLink}
          cardUrl={cardUrl}
          recordingLink={recordingLink}
          songLink={songLink}
          giftLogo={giftLogo}
          giftClaimUrl={giftClaimUrl}
          setSongNameVisible={setSongNameVisible}
          setIsOpen={setIsOpen}
          modalIsOpen={modalIsOpen}
          shareModalIsOpen={shareModalIsOpen}
          setShareModelOpen={setShareModelOpen}
        />
      )}

      {shareModalIsOpen ? (
        <Modal
          isOpen={shareModalIsOpen}
          style={customStyles}
          contentLabel="Thank You Modal"
          onRequestClose={() => setShareModelOpen(false)}
          shouldCloseOnOverlayClick={true}
        >
          <button
            onClick={() => setShareModelOpen(false)}
            className="modal-close-button2"
            aria-label="Close Modal"
          >
            &times;
          </button>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingTop: "20px",
            }}
          >
            <FacebookShareButton
              url={`https://viewer.jivebird.com/${id}`}
              quote={"Click to view your JB"}
              hashtag={"#hashtag"}
              description={"aiueo"}
              className="Demo__some-network__share-button"
            >
              <FacebookIcon />
            </FacebookShareButton>
            <LinkedinShareButton
              url={`https://viewer.jivebird.com/${id}`}
              title="JB SHARE Title"
              summary="View here"
              source="jivebird.com"
            >
              <LinkedinIcon />
            </LinkedinShareButton>
            <TwitterShareButton
              url={`https://viewer.jivebird.com/${id}`}
              title="JiveBird"
              via="jbshare"
              hashtags={["jivebird", "jbshare"]}
            >
              <TwitterIcon />
            </TwitterShareButton>
            <WhatsappShareButton
              url={`https://viewer.jivebird.com/${id}`}
              title="JiveBird"
              separator=": "
            >
              <WhatsappIcon />
            </WhatsappShareButton>
          </div>
        </Modal>
      ) : null}

      {modalIsOpen ? (
        <Modal
          isOpen={modalIsOpen}
          style={customStyles1}
          contentLabel="Thank You Modal"
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true}
        >
          <div
            className="thankyou-modal"
            onClick={() => window.open("https://web.jivebird.com", "_blank")}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
              className="modal-close-button"
              aria-label="Close Modal"
            >
              &times;
            </button>

            <img
              className="bird-swal"
              alt="Thank You Bird"
              src="https://jivebirdbucketprod.s3.eu-west-2.amazonaws.com/webapp-assets/thank.png"
            />
            <label className="text-swal">
              Say Thank You with <br />a{" "}
              <span className="free-jb">FREE JiveBird</span>
            </label>

            <button
              onClick={sendThanksEmail}
              disabled={sendingThanks}
              style={{
                marginTop: "16px",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#f36b1c",
                color: "#fff",
                fontWeight: 700,
                fontSize: "14px",
              }}
            >
              {sendingThanks ? "Sending..." : "Send Thank You Email"}
            </button>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default JiveBirdTemp;
